import Vue from 'vue'
import store from '@/store'

import permission from '@/utils/permission'

Vue.directive('permission', {
  inserted: function (el, binding) {
    const { value } = binding
    const {loginUser} = store.getters
    const roles = [loginUser.rid]
    const permissionRoles = value
    let hasPermission = false
    hasPermission = roles.some(role => {
      console.log(permissionRoles, role)
      return permissionRoles.includes(role)
    })
    if (!hasPermission) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
})
Vue.directive('permission-disabled', {
  inserted: function (el, binding) {
    const { value } = binding
    const {loginUser} = store.getters
    const roles = [loginUser.rid]
    const permissionRoles = value
    let hasPermission = false
    hasPermission = roles.some(role => {
      return permissionRoles.includes(role)
    })
    if (hasPermission) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
})

Vue.config.warnHandler = function (msg, vm, trace) {
  if (!vm || !vm.$vnode || !vm.$vnode.data) return
  const {directives} = vm.$vnode.data
  if (directives && directives.some(e => e.name === 'auth')) return
  console.error(`[Vue warn]: ${msg}${trace}`)
}
